import { unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";

const _withScopeId = n => (_pushScopeId("data-v-3e0f9646"), n = n(), _popScopeId(), n);

const _hoisted_1 = {
  class: "lang-change"
};
const _hoisted_2 = {
  class: "language"
};

const _hoisted_3 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "flag flag-en"
}, null, -1));

const _hoisted_4 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "English", -1));

const _hoisted_5 = [_hoisted_3, _hoisted_4];

const _hoisted_6 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "flag flag-tw"
}, null, -1));

const _hoisted_7 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "繁體", -1));

const _hoisted_8 = [_hoisted_6, _hoisted_7];

const _hoisted_9 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "flag flag-hin"
}, null, -1));

const _hoisted_10 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "हिन्दी", -1));

const _hoisted_11 = [_hoisted_9, _hoisted_10];

const _hoisted_12 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "flag flag-fr"
}, null, -1));

const _hoisted_13 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Francés", -1));

const _hoisted_14 = [_hoisted_12, _hoisted_13];

const _hoisted_15 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "flag flag-span"
}, null, -1));

const _hoisted_16 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Español", -1));

const _hoisted_17 = [_hoisted_15, _hoisted_16];

const _hoisted_18 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "flag flag-de"
}, null, -1));

const _hoisted_19 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Deutsch", -1));

const _hoisted_20 = [_hoisted_18, _hoisted_19];

const _hoisted_21 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "flag flag-it"
}, null, -1));

const _hoisted_22 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Italiano", -1));

const _hoisted_23 = [_hoisted_21, _hoisted_22];

const _hoisted_24 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "flag flag-th"
}, null, -1));

const _hoisted_25 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "แบบไทย", -1));

const _hoisted_26 = [_hoisted_24, _hoisted_25];

const _hoisted_27 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "flag flag-pt"
}, null, -1));

const _hoisted_28 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Português", -1));

const _hoisted_29 = [_hoisted_27, _hoisted_28];

const _hoisted_30 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "flag flag-tr"
}, null, -1));

const _hoisted_31 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Türkçe", -1));

const _hoisted_32 = [_hoisted_30, _hoisted_31];

const _hoisted_33 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "flag flag-kr"
}, null, -1));

const _hoisted_34 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "한국인", -1));

const _hoisted_35 = [_hoisted_33, _hoisted_34];

const _hoisted_36 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "flag flag-jp"
}, null, -1));

const _hoisted_37 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "日本語", -1));

const _hoisted_38 = [_hoisted_36, _hoisted_37];

const _hoisted_39 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "flag flag-ru"
}, null, -1));

const _hoisted_40 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Pусский", -1));

const _hoisted_41 = [_hoisted_39, _hoisted_40];

const _hoisted_42 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "flag flag-ar"
}, null, -1));

const _hoisted_43 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "اللغة العربية", -1));

const _hoisted_44 = [_hoisted_42, _hoisted_43];

const _hoisted_45 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "flag flag-nl"
}, null, -1));

const _hoisted_46 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Dutch", -1));

const _hoisted_47 = [_hoisted_45, _hoisted_46];
import { ref } from 'vue';
import store from '@/store';
import { GlobalOutlined } from '@ant-design/icons-vue';
export default {
  __name: 'LangChange',
  emits: ['select'],

  setup(__props, {
    emit
  }) {
    const langShow = ref(false);

    const langSelect = lang => {
      emit('select', lang);
      langShow.value = false;
    };

    return (_ctx, _cache) => {
      const _component_a_modal = _resolveComponent("a-modal");

      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_unref(GlobalOutlined), {
        style: {
          "font-size": "20px"
        },
        onClick: _cache[0] || (_cache[0] = $event => langShow.value = true)
      }), _createVNode(_component_a_modal, {
        visible: langShow.value,
        "onUpdate:visible": _cache[16] || (_cache[16] = $event => langShow.value = $event),
        footer: null
      }, {
        default: _withCtx(() => [_createElementVNode("div", _hoisted_2, [_createElementVNode("div", {
          class: _normalizeClass(["select-item", {
            choose: _unref(store).lang === 'en'
          }]),
          onClick: _cache[1] || (_cache[1] = $event => langSelect('en'))
        }, _hoisted_5, 2), _createElementVNode("div", {
          class: _normalizeClass(["select-item", {
            choose: _unref(store).lang === 'tc'
          }]),
          onClick: _cache[2] || (_cache[2] = $event => langSelect('tc'))
        }, _hoisted_8, 2), _createElementVNode("div", {
          class: _normalizeClass(["select-item", {
            choose: _unref(store).lang === 'hin'
          }]),
          onClick: _cache[3] || (_cache[3] = $event => langSelect('hin'))
        }, _hoisted_11, 2), _createElementVNode("div", {
          class: _normalizeClass(["select-item", {
            choose: _unref(store).lang === 'fr'
          }]),
          onClick: _cache[4] || (_cache[4] = $event => langSelect('fr'))
        }, _hoisted_14, 2), _createElementVNode("div", {
          class: _normalizeClass(["select-item", {
            choose: _unref(store).lang === 'span'
          }]),
          onClick: _cache[5] || (_cache[5] = $event => langSelect('span'))
        }, _hoisted_17, 2), _createElementVNode("div", {
          class: _normalizeClass(["select-item", {
            choose: _unref(store).lang === 'de'
          }]),
          onClick: _cache[6] || (_cache[6] = $event => langSelect('de'))
        }, _hoisted_20, 2), _createElementVNode("div", {
          class: _normalizeClass(["select-item", {
            choose: _unref(store).lang === 'it'
          }]),
          onClick: _cache[7] || (_cache[7] = $event => langSelect('it'))
        }, _hoisted_23, 2), _createElementVNode("div", {
          class: _normalizeClass(["select-item", {
            choose: _unref(store).lang === 'th'
          }]),
          onClick: _cache[8] || (_cache[8] = $event => langSelect('th'))
        }, _hoisted_26, 2), _createElementVNode("div", {
          class: _normalizeClass(["select-item", {
            choose: _unref(store).lang === 'pt'
          }]),
          onClick: _cache[9] || (_cache[9] = $event => langSelect('pt'))
        }, _hoisted_29, 2), _createElementVNode("div", {
          class: _normalizeClass(["select-item", {
            choose: _unref(store).lang === 'tr'
          }]),
          onClick: _cache[10] || (_cache[10] = $event => langSelect('tr'))
        }, _hoisted_32, 2), _createElementVNode("div", {
          class: _normalizeClass(["select-item", {
            choose: _unref(store).lang === 'kr'
          }]),
          onClick: _cache[11] || (_cache[11] = $event => langSelect('kr'))
        }, _hoisted_35, 2), _createElementVNode("div", {
          class: _normalizeClass(["select-item", {
            choose: _unref(store).lang === 'jp'
          }]),
          onClick: _cache[12] || (_cache[12] = $event => langSelect('jp'))
        }, _hoisted_38, 2), _createElementVNode("div", {
          class: _normalizeClass(["select-item", {
            choose: _unref(store).lang === 'ru'
          }]),
          onClick: _cache[13] || (_cache[13] = $event => langSelect('ru'))
        }, _hoisted_41, 2), _createElementVNode("div", {
          class: _normalizeClass(["select-item", {
            choose: _unref(store).lang === 'ar'
          }]),
          onClick: _cache[14] || (_cache[14] = $event => langSelect('ar'))
        }, _hoisted_44, 2), _createElementVNode("div", {
          class: _normalizeClass(["select-item", {
            choose: _unref(store).lang === 'nl'
          }]),
          onClick: _cache[15] || (_cache[15] = $event => langSelect('nl'))
        }, _hoisted_47, 2)])]),
        _: 1
      }, 8, ["visible"])]);
    };
  }

};